export default __webpack_public_path__ + "static/media/logo.9fc798a6.svg";